import { PaginatedResponse } from "@/app/api/types";
import { ISelectFieldOption } from "@/app/fields/types";
import { SelectFieldFilter } from "./SelectFieldFilter";

export const BooleanFieldFilter = ({
  field,
  label,
  true_filter_label,
  false_filter_label,
  isDisabled,
}: {
  field: string;
  label: string;
  true_filter_label: string;
  false_filter_label: string;
  isDisabled: boolean;
}) => {
  const getFieldOptions = async (): Promise<
    PaginatedResponse<ISelectFieldOption>
  > =>
    new Promise((resolve) => {
      resolve({
        count: 1,
        page: 1,
        page_size: 100,
        results: [
          {
            value: "true",
            label: true_filter_label,
            group: null,
          },
          {
            value: "false",
            label: false_filter_label,
            group: null,
          },
        ],
      });
    });

  return (
    <SelectFieldFilter
      isDisabled={isDisabled}
      field={field}
      label={label}
      getFieldOptions={getFieldOptions}
    />
  );
};
